import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { FooterFull } from "../../../components/FooterFull";
import { GetCourseWidget } from "../../../components/GetCourseWidget";

import {
  Screen1,
  Target,
  Results,
  Founder,
  Advance,
  Cost
} from "../../../components/LandingTemplates/time_management";

const TITLE = 'Тайм-менеджмент и повышение эффективности';
const DESCRIPTION = 'Онлайн-курс от Advance';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1/>
      <Target/>
      <Results/>
      <Founder/>
      <Advance/>
      <Cost
        widget={<GetCourseWidget hash={'e814ce70f8529c1538de9557d86a39bf4488c347'} id={'770828'}/>}
      />
    </main>

    <FooterFull />
  </DefaultLayout>
);

export default Page;
